// Phase 85.A.49 — Emergent OAuth bridge DEPRECATED.
// Trang này CHỈ giữ để xử lý URL bookmark cũ — user đến đây sẽ được
// redirect về /login với thông báo dùng nút Google mới (GIS).
//
// Pre-Phase 85.A.49 flow (legacy):
//   1. User click Google → redirect auth.emergentagent.com.
//   2. Emergent return về /auth/callback#session_id=...
//   3. FE POST /api/auth/google/exchange { session_id }.
//
// Phase 85.A.49 cut-over (user choice 3b):
//   1. User click Google button → GIS popup → id_token (no redirect).
//   2. FE POST /api/auth/google/verify-id-token { id_token }.
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowsClockwise } from "@phosphor-icons/react";

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to /login với query param để hiện toast giải thích.
    const t = setTimeout(() => {
      navigate("/login?legacy_oauth=1", { replace: true });
    }, 600);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#06080F] px-6">
      <div className="max-w-md w-full text-center space-y-4 py-12">
        <ArrowsClockwise size={40} className="text-white/80 mx-auto animate-spin" weight="bold" />
        <h2 className="text-white font-bold text-base">Đang chuyển sang trang đăng nhập mới…</h2>
        <p className="text-white/60 text-sm leading-relaxed">
          Phương thức đăng nhập Google đã được nâng cấp. Tự động chuyển trong 1 giây.
        </p>
      </div>
    </div>
  );
}
